import React from 'react';
import { useSwipeable } from 'react-swipeable';

interface GlobalSwipeWrapperProps {
  onSwipeLeft: () => void;
  onSwipeRight: () => void;
  children: React.ReactNode;
}

const GlobalSwipeWrapper: React.FC<GlobalSwipeWrapperProps> = ({
  onSwipeLeft,
  onSwipeRight,
  children,
}) => {
  const swipeHandlers = useSwipeable({
    onSwipedLeft: onSwipeLeft,
    onSwipedRight: onSwipeRight,
    // TypeScript may complain about these properties; cast as any:
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  } as any);

  return (
    <div {...swipeHandlers} style={{ width: '100%', height: '100%' }}>
      {children}
    </div>
  );
};

export default GlobalSwipeWrapper;
